import {adicRestApi, adicRestApiJournalUrl} from '../index';

export const getJournalSectionList = async () => {
  const url = adicRestApiJournalUrl
    .segment("/section/list")
    .toString();

  const { data } = await adicRestApi.get(url);
  return data;
};
export const getJournalList = async (journalUrl) => {
  const url = adicRestApiJournalUrl
    .segment("/column/list")
    .query(journalUrl)
    .toString();

  const { data } = await adicRestApi.get(url);
  return data;
};

export const getJournalDetail = async (ukey) => {
  const url = adicRestApiJournalUrl
    .segment("/column/info")
    .query(ukey)
    .toString();

  const { data } = await adicRestApi.get(url);
  return data;
};
